import { Actions, Mutations } from "@/store/enums/StoreEnums";

const state = () => {
  return {
    breadcrumbs: [],
    currentPath: '',
    showBack: true,
    backRoute: '/',
    showOverlay: false,
    sidebarOpen: true,
    clientHeight: window.innerHeight
  };
};

// getters
const getters = {
  breadcrumbs: (state) => {
    return state.breadcrumbs
  },
  currentPath: (state) => {
    return state.currentPath
  },
  showBack: (state) => {
    return state.showBack
  },
  backRoute: (state) => {
    return state.backRoute
  },
  showOverlay: (state) => {
    return state.showOverlay
  },
  sidebarOpen: (state) => {
    return state.sidebarOpen
  },
  clientHeight: (state) => {
    return state.clientHeight
  },
};

// actions
const actions = {
};

// mutations
const mutations = {
  [Mutations.SET_BREADCRUMB](state, payload) {
    state.breadcrumbs = payload;
  },
  [Mutations.SET_CURRENT_PATH](state, payload) {
    state.currentPath = payload;
  },
  [Mutations.SET_BACK_SHOW](state, payload) {
    state.showBack = payload;
  },
  [Mutations.SET_BACK_ROUTE](state, payload) {
    state.backRoute = payload;
  },
  [Mutations.SET_SHOW_OVERLAY](state, payload) {
    state.showOverlay = payload;
  },
  [Mutations.SET_SIDEBAR_OPEN](state, payload) {
    state.sidebarOpen = payload;
  },
  [Mutations.SET_CLINET_HEIGHT](state, payload) {
    state.clientHeight = payload;
  },
};

export default {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations
};
